export default __webpack_public_path__ + "static/media/ImageNotFound.a9edee36.png";